import { useQuery } from "@tanstack/react-query";

import { listOneCBases, ONEC_BASES_QUERY_KEY } from "@/api/onec_bases";

/** Справочник баз 1С + состояние сессии. Один ключ на шапку, «Подключение 1С»
 *  и админ-страницу: правка справочника сразу видна везде. */
export function useOneCBases(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ONEC_BASES_QUERY_KEY,
    queryFn: listOneCBases,
    enabled: options.enabled ?? true,
  });
}

/** Текст, если у SSO-сессии нет пользователя 1С (бэкенд тогда отвечает 403
 *  `onec_not_configured`); null — есть. */
export function ssoOneCProblem(hasOnecUnf: boolean): string | null {
  return hasOnecUnf
    ? null
    : "В учётной записи SSO не задан пользователь 1С (onec_unf) — обратитесь к администратору.";
}
